import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { OpenInNew } from '@mui/icons-material'

const DialogForMac = ({ open, handleClose }: { open: boolean; handleClose: (userAccept: boolean) => void }) => {
  return (
    <Dialog
      open={open}
      keepMounted
      onClose={() => handleClose(false)}
      aria-describedby='alert-dialog-slide-description'
    >
      <DialogTitle>
        <FormattedMessage id='userArea.launcherSupport' />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-slide-description'>
          <FormattedMessage id='userArea.launcher_mac' />
          <br />
          <br />
          <Button
            variant='outlined'
            style={{ padding: '0px 20px' }}
            endIcon={<OpenInNew />}
            href='https://countersketchstreaming.gemvision.cloud/login'
            target='_blank'
            rel='noopener noreferrer'
          >
            <FormattedMessage id='common.open' />
          </Button>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)}>
          <FormattedMessage id='common.cancel' />
        </Button>
        <Button variant='contained' onClick={() => handleClose(true)}>
          <FormattedMessage id='common.download' />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogForMac
